import formBaseMixin from '../../../components/form/form-base-mixin.js'
import {locationChangerMixin} from "../../../mixins/location-changer-mixin"

import {OPERATION_RECACL_TYPE_NORMATIVE, OPERATION_RECACL_TYPE_TARIFF} from "../../../config/config"

export default {
  mixins: [locationChangerMixin, formBaseMixin],
  data () {
    return {
      tabView: 'tab1',
      fields: {
        start: '',
        end: '',
        value: '',
        type: '',
        branch: '',
        operation_day: ''
      }
    }
  },
  title () {
    return this.formTitle
  },
  computed: {
    normatives () {
      return this.$store.getters.readUrlEndpoint(
        this.getNormatives()
      ) || {data: []}
    },
    tariffs () {
      return this.$store.getters.readUrlEndpoint(
        this.getTariffs()
      ) || {data: []}
    },
    formTitle () {
      return 'Перерасчет'
    },
    types () {
      return [
        {id: OPERATION_RECACL_TYPE_TARIFF, name: 'По тарифу'},
        {id: OPERATION_RECACL_TYPE_NORMATIVE, name: 'По нормативу'}
      ]
    },
    parameters () {
      if (this.fields.type === OPERATION_RECACL_TYPE_NORMATIVE ) {
        return this.normatives.data
      }
      if (this.fields.type === OPERATION_RECACL_TYPE_TARIFF ) {
        return this.tariffs.data
      }
      return []
    }
  },
  methods: {
    /**
     * @override
     * @param fields
     */
    prepareFieldsForSend (fields) {
      return this.prepareLocationFieldsForSend(fields)
    },
    /**
     * @override
     */
    getSuccessTitle() {
      return 'Счета отправлены в очередь на пересчет'
    }
  },
  asyncData ({store, methods}) {
    return Promise.all([
      store.dispatch('updateUrlEndpoint', {endpoint: methods.getNormatives()}),
      store.dispatch('updateUrlEndpoint', {endpoint: methods.getTariffs()}),
      store.dispatch('updateUrlEndpoint', {endpoint: methods.getPostOfficesEndpoint()})
    ])
  }
}
